import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Button, Dropdown, Form, Card, Modal } from "react-bootstrap";
import { urls } from "../../URLs";
import { GlobalContext } from "../../Context/GlobalState";
import {
  dmtSuccessPopup,
  dmtTransactionFailedPopup,
  dmtTransactionSuccessPopup,
} from "../../utils/Models";
import swal from "sweetalert";
import { BASE_URL_API, BASE_URL_API_TRANXT_API } from "../../utils/Constants";
import { formatDateDDMMYYHHMM, generateHashKey2 } from "../../utils/utilFuctions";
import { sendMoneyAPI2 } from "../../api/dmt/DmtApi";

const { DMT1Url } = urls;

const Sidebar22 = {
  position: "fixed",
  right: "0",
  width: "0px",
  height: "600px",
  overflow: "scroll",
  background: "#FFF",
};

const AdminDmtSendMoneyModal = ({ modalstate, callback }) => {
  const {
    wallet,
    setWalletBalance,
    refreshWallet,
    setTransactionLoaderState,
    Profileinfo,
  } = useContext(GlobalContext);

  const { details, isOpen, setModelState, refreshLimit } = modalstate;

  const { remitter } = details
  const [amountError, setAmountError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const tPinLength = 6;
  const [amount, setAmount] = useState(0);
  const [bcAgentId, setBcAgentId] = useState("");
  const [tPin, setTPin] = useState("");
  const { benificiary, user, successToast, errorToast, limit, remitterNumber } =
    details;
  const [charges, setCharges] = useState(0);
  const [tpinShow, setTpinShow] = useState(false);

  const close = () => {
    setTPin("");
    setModelState({ ...modalstate, isOpen: false });
  };
  //tested_shweta
  const sendMoney = async () => {
    let dailyAvailableTxntCount = 0;
    let monthlyAvailableTxntCount = 0;
    if (remitter
      && remitter.routes
      && remitter.routes.length > 0) {
      dailyAvailableTxntCount = remitter?.routes[0].dailyAvailableTxntCount;
      monthlyAvailableTxntCount = remitter?.routes[0].monthlyAvailableTxntCount;
    }
    const reqLimit = Math.ceil(Number(amount) / 5000);
    let beneNumber = benificiary.recipient_mobile;
    if (beneNumber == null || beneNumber == "") {
      beneNumber = remitterNumber;
    }
    if (tPin == "" || tPin.length < tPinLength) {
      errorToast("Please enter valid T Pin");
      return;
    }
    if (Number(amount) < 100 || Number(amount) > 25000) {
      swal("Failed", "Please Enter amount in Range 100 to 25000", "error");
      return;
    }
    if (Number(amount) > limit) {
      swal(
        "Failed",
        `You have exceeded your daily limit. Your available limit is ${details.limit}`,
        "error"
      );
      return;
    }

    if (Number(dailyAvailableTxntCount) < reqLimit) {
      swal(
        "Failed",
        `You have exceeded your daily transaction count limit.`,
        "error"
      );
      return;
    }
    if (Number(monthlyAvailableTxntCount) < reqLimit) {
      swal(
        "Failed",
        `You have exceeded your monthly transaction count limit.`,
        "error"
      );
      return;
    }

    setIsLoading(true);
    setTransactionLoaderState(true);

    let accNo = benificiary.account;

    if (accNo.toString().length < 10) {
      accNo = "0" + accNo;
    }


    setTransactionLoaderState(true);

    try {
      const request = {
        "beneMobile": beneNumber,
        "amount": amount + ".00",
        "txnType": "IMPS",
        "userid": "BUMPPYR1001",
        "ifsc": benificiary.ifsc,
        "tpin": tPin,
        "accountno": accNo,
        "paytmlimit": limit,
        "bankitlimit": limit,
        "beneName": benificiary.recipient_name.toString().replace("&", ""),
        "remitterNumber": remitterNumber,
        "bcAgentId": bcAgentId
      }

      const res = await sendMoneyAPI2(request);
      if (res.status == "0") {
        setModelState({ ...modalstate, isOpen: false });
        refreshLimit();

        callback({ amount: amount, message: "Amount transfer successfull", status: "success", date: formatDateDDMMYYHHMM(new Date()), transactionId: res?.data?.tid });
      } else if (res.status == "2") {
        // swal("Processing", res.msg, "warning");
        setModelState({ ...modalstate, isOpen: false });
        refreshLimit();
        callback({ amount: amount, message: res.msg, status: "pending", date: formatDateDDMMYYHHMM(new Date()), transactionId: res?.data?.tid });
      }
      else {
        setModelState({ ...modalstate, isOpen: false });
        // dmtTransactionFailedPopup("", `${amount}.00`, res.msg);
        callback({ amount: amount, message: res.msg, status: "failed", date: formatDateDDMMYYHHMM(new Date()), transactionId: res?.data?.tid });
      }
      setIsLoading(false);
      setTransactionLoaderState(false);
      refreshWallet();
    } catch (error) {
      setIsLoading(false);
      setTransactionLoaderState(false);
      errorToast("Amount transfer failed");
      dmtTransactionFailedPopup("", `${amount}.00`, "Amount transfer failed");
      console.log("error", error);
    }
  };
  useEffect(() => {
    console.log("Sidebar changes");
    setAmount(0);
    setCharges(0);
    setTPin("");
  }, [details, isOpen]);

  const showTPinClick = () => {
    setTpinShow(!tpinShow);
  };

  const openInNewTab = (data) => {
    localStorage.setItem(
      "print",
      JSON.stringify({ ...data, shopName: Profileinfo.shopname })
    );
    const newWindow = window.open(
      `/pages/print?id=${data.tid}&type=DMT / IMPS`,
      "",
      "height=600,width=800'"
    );
    if (newWindow) newWindow.opener = null;
  };

  const dateFormatter = (date = new Date()) => {
    return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
      }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  const printReceipt = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let remitterMobile = "";
    // if (mobile.length > 9) {
    //   remitterMobile = mobile;
    // }

    var raw = JSON.stringify({
      userID: "BUMPPYR1001",
      fromdate: dateFormatter(),
      todate: dateFormatter(),
      mobile: remitterMobile,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      fetch(
        // `${BASE_URL_API_TRANXT_API}/api/retailers/get_retailer_dmt_report.aspx`,
        `${BASE_URL_API}/api/Apitranxt/get_retailer_dmt_report`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0" && result.data) {
            //setData(result.data);
            if (result.data.length > 0) {
              openInNewTab(result.data[0]);
            }
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  // dmtSuccessPopup("0.00", "Amount transfer successfull", printReceipt);

  return (
    <Modal
      show={isOpen}
      onHide={() => setModelState({ ...modalstate, isOpen: false })}
      aria-labelledby="example-modal-sizes-title-md"
    >
      <Modal.Header closeButton>
        <Modal.Title> Send Money</Modal.Title>
      </Modal.Header>
      {/* <SweetAlert
      show={popupState}
      title="Are you sure?"
      text="Rs 3 deducted from your Account"
      type="warning"
      showCancelButton
      onConfirm={() => {
        addBeneficiaryVerify();
        setPopupState(false);
      }}
    /> */}

      {isOpen && (
        <Modal.Body
          style={{ width: "100%", display: "block" }}
          className="account"
        >
          <Card style={{ margin: "10px", padding: "10px" }}>
            <div style={{ display: "flex" }}>
              <span>Domestic Money Transfer Limit</span>
              <strong style={{ color: "green", margin: "0 0 0 1rem" }}>
                {details.limit}{" "}
              </strong>
            </div>
          </Card>
          <Card style={{ margin: "10px", padding: "10px" }}>
            <Form.Group>
              <Form.Label>BC Agent Code</Form.Label>
              <Form.Control
                type="text"
                className="form-control rounded-0"
                aria-label="Notes"
                aria-describedby="basic-addon1"
                placeholder="BC Agent Code"
                value={bcAgentId}
                onChange={(e) => {
                  setBcAgentId(e.target.value);
                }
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Beneficiary Name</Form.Label>
              <Form.Control
                type="text"
                className="form-control rounded-0"
                aria-label="Notes"
                aria-describedby="basic-addon1"
                placeholder="Beneficiary Name"
                value={benificiary.recipient_name}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Beneficiary A/C</Form.Label>
              <Form.Control
                type="text"
                className="form-control rounded-0"
                aria-label="Notes"
                aria-describedby="basic-addon1"
                placeholder="Beneficiary A/C"
                value={benificiary.account}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                className="form-control rounded-0"
                aria-label="Notes"
                aria-describedby="basic-addon1"
                placeholder="AMOUNT"
                style={{ display: "flex", alignItems: "center" }}
                value={amount}
                onChange={(e) => {
                  setAmount(e.target.value);
                  const amt = Number(e.target.value);
                  if (amt < 100 || amt > 25000) {
                    setAmountError(
                      "Kindly enter an amount within the specified range of 100 to 25000"
                    );
                  } else {
                    setAmountError("");
                  }

                  let c = Number(e.target.value) / 100;
                  if (Number(c) < 10) {
                    c = 10;
                  }
                  if (Number(c) > 250) {
                    c = 250;
                  }
                  setCharges(c);
                }}
              />
            </Form.Group>
            <div className="row justify-content-between">
              {amountError && (
                <span
                  style={{ color: "red", padding: "0px 0px 1rem 0px" }}
                >{`${amountError}`}</span>
              )}

              {charges > 0 && (
                <span
                  style={{ color: "red", padding: "0px 0px 1rem 0px" }}
                >{`Charges Rs ${charges}`}</span>
              )}
            </div>
            <Form.Group>
              <div className="input-group">
                <div className="input-group-prepend bg-transparent">
                  <span className="input-group-text bg-transparent border-right-0 no-glow">
                    <i className="mdi mdi-lock-outline text-primary"></i>
                  </span>
                </div>
                <input
                  autocomplete="new-password"
                  autoCorrect="off"
                  autoSave="new-password"
                  type={tpinShow ? "text" : "password"}
                  className="form-control form-control-lg border-left-0 border-right-0 no-glow"
                  id="tpin"
                  placeholder="T Pin"
                  value={tPin}
                  onChange={(e) => {
                    setTPin(e.target.value);
                  }}
                />
                <div className="input-group-prepend bg-transparent">
                  <span
                    className="input-group-text bg-transparent border-left-0 no-glow"
                    onClick={showTPinClick}
                    style={{ borderRadius: "4px" }}
                  >
                    <i
                      className={`mdi text-primary ${tpinShow ? "mdi-eye" : "mdi-eye-off"
                        }`}
                    ></i>
                  </span>
                </div>
              </div>
            </Form.Group>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                className="rounded-0"
                style={{ margin: "0px 10px", flex: "1" }}
                variant="primary"
                onClick={sendMoney}
                disabled={isLoading}
              >
                {isLoading ? "Transaction Processing.." : "Transfer Now"}
              </Button>
              <Button
                onClick={close}
                className="rounded-0"
                style={{ margin: "0px 10px", flex: "1" }}
                variant="success"
              >
                {" "}
                Cancel
              </Button>
            </div>
          </Card>
        </Modal.Body>
      )}
    </Modal>
  );
};

export default AdminDmtSendMoneyModal;
